import { Type } from 'class-transformer';
import {
  IsArray,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';

export class GetPolicyPositionsDto {
  @IsNotEmpty()
  @IsUUID()
  companyId: string;

  @IsArray()
  @Type(() => String)
  @IsOptional()
  unitIds?: string[];

  @IsOptional()
  @IsNumber()
  limit?: number;

  @IsOptional()
  @IsNumber()
  offset?: number;

  @IsOptional()
  @IsString()
  query?: string;

  @IsArray()
  @Type(() => String)
  @IsOptional()
  ids?: string[];
}
